import { BaseAPIClient } from "./baseApi";
import { installMessagesApi } from "./messagesApi";

const POST = "POST";
const PUT = "PUT";
const GET = "GET";
const PATCH = "PATCH";
const DELETE = "DELETE";

export class PitchApi extends BaseAPIClient {
  validateEmail(email) {
    return this.call("/check-email", GET, email);
  }

  signIn(credentials) {
    return this.call("/sign-in", POST, credentials);
  }

  signUp(customerData) {
    return this.call("/sign-up", POST, customerData);
  }

  // Apenas confere o link: a conta nao e ativada aqui. O token e obrigatorio --
  // sem ele a API recusa, porque o link antigo (so com o id) nunca expirava.
  activateAccount(id, token) {
    return this.call(
      `/validate-email/${id}`,
      GET,
      token ? { token } : undefined
    );
  }

  // Ativacao do auto-cadastro: a senha ja existe, entao confirmar o codigo do
  // email e o unico passo que falta.
  confirmActivation(data) {
    return this.call("/activate", POST, data);
  }

  requestRecoverPassword(email) {
    return this.call("/recover", POST, { email });
  }

  validateOtp(otp) {
    return this.call(`/valid/${otp}`, GET);
  }

  updatePassword(data) {
    return this.call("/password", POST, data);
  }

  showProfile() {
    return this.call("/profile", GET);
  }

  updateProfile(data) {
    return this.call("/profile", PUT, data);
  }

  completePersonalInfo(data) {
    return this.call("/profile/personal-info", PUT, data);
  }

  removerDisponibilidade(id) {
    return this.call(`/profile/update/${id}`, DELETE);
  }

  doAMatch(params = {}) {
    return this.call("/match", GET, params);
  }

  requestJoin(data) {
    return this.call("/join", POST, data);
  }

  // Migra o aluno para o estudo independente: desvincula das turmas e o coloca
  // na fila de designacao de tutor do administrativo.
  switchToIndependentStudy() {
    return this.call("/study-mode/independent", PUT);
  }

  getCourse() {
    return this.call("/course", GET);
  }

  // Aluno solo: um modulo com suas aulas (navegacao cards -> aulas).
  getCourseModule(id) {
    return this.call(`/course/module/${id}`, GET);
  }

  getDashboard() {
    return this.call("/dashboard", GET);
  }

  getWallet() {
    return this.call("/wallet", GET);
  }

  getFinance(params) {
    return this.call("/finance", GET, params);
  }

  // Pitch Coins (card 17trt6jd8uu): so leitura.
  getCoinsSummary() {
    return this.call("/coins/summary", GET);
  }

  getCoinsStatement(params) {
    return this.call("/coins/statement", GET, params);
  }

  getCoinsEarnGuide() {
    return this.call("/coins/earn", GET);
  }

  // Campanhas em andamento para o aluno (destaque da pagina).
  getCoinCampaigns() {
    return this.call("/coins/campaigns", GET);
  }

  // Etapa 4: ranking de alunos (geral e por professor) do semestre.
  getCoinRanking() {
    return this.call("/coins/ranking", GET);
  }

  // Etapa 4: selos com o andamento de cada um.
  getCoinBadges() {
    return this.call("/coins/badges", GET);
  }

  getCoinBenefits() {
    return this.call("/coins/benefits", GET);
  }

  getCoinRedemptions() {
    return this.call("/coins/redemptions", GET);
  }

  requestCoinRedemption(benefitId) {
    return this.call("/coins/redemptions", POST, { benefitId });
  }

  getCoinReferrals() {
    return this.call("/coins/referrals", GET);
  }

  createCoinReferral(email, target) {
    return this.call("/coins/referrals", POST, { email, target });
  }

  cancelCoinRedemption(id) {
    return this.call(`/coins/redemptions/${id}/cancel`, POST);
  }

  saveCard(payload) {
    return this.call("/cards", POST, payload);
  }

  // Forma de pagamento da mensalidade: "credit_card" | "pix" | "boleto".
  // A API responde 422 com o que falta no perfil quando ainda não é possível.
  // Idioma do Connect salvo no aluno (seletor da barra lateral).
  updateLanguage(language) {
    return this.call("/profile/language", PATCH, { language });
  }

  // Tema do Connect ("light" | "dark"), salvo no usuario como o idioma.
  updateTheme(theme) {
    return this.call("/profile/theme", PATCH, { theme });
  }

  setPaymentMethod(method) {
    return this.call("/payment-method", PUT, { method });
  }

  getCourseContent(id) {
    return this.call(`/course/${id}`, GET);
  }

  addCourseContentNote(id, note) {
    return this.call(`/course/${id}/add-note`, POST, { note });
  }

  // Só o aluno sem professor conclui a própria aula; a API recusa os demais.
  setCourseCompletion(id, completed) {
    return this.call(`/course/${id}/complete`, PUT, { completed });
  }

  // Card 86aknajnn: `month` no formato YYYY-MM recorta o extrato.
  getGeneralClassAttendance(month) {
    const query = month ? `?month=${encodeURIComponent(month)}` : "";
    return this.call(`/general-classes/attendance${query}`, GET);
  }

  calendar() {
    return this.call(`/calendar`, GET);
  }

  // Card 86aknb3ra: conversação/monitoria elegíveis, inclusive as recusadas.
  generalClasses() {
    return this.call(`/general-classes`, GET);
  }

  groups() {
    return this.call("/groups", GET);
  }

  getStudyGroupAttendance(id, params) {
    return this.call(`/groups/${id}/attendance`, GET, params);
  }

  getNotifications(category, unreadOnly = false) {
    const params = [];
    if (category) params.push(`category=${encodeURIComponent(category)}`);
    if (unreadOnly) params.push("unread=true");
    const query = params.length ? `?${params.join("&")}` : "";
    return this.call(`/notifications${query}`, GET);
  }

  getUnreadNotificationsCount() {
    return this.call("/notifications/unread-count", GET);
  }

  readNotification(id) {
    return this.call(`/notifications/${id}`, PUT);
  }

  unreadNotification(id) {
    return this.call(`/notifications/${id}/unread`, PUT);
  }

  // Card 86akj8ptp: o aluno usou o botão da comunicação (métrica de cliques
  // da Central de Comunicação).
  clickNotification(id) {
    return this.call(`/notifications/${id}/click`, PUT);
  }

  // Card 86akj8q08: plano de estudos do aluno autônomo.
  getStudyPlans() {
    return this.call("/study-plans", GET);
  }

  getStudyPlan(id) {
    return this.call(`/study-plans/${id}`, GET);
  }

  setStudyPlanItemDone(planId, itemId, done) {
    return this.call(`/study-plans/${planId}/items/${itemId}/done`, PUT, {
      done,
    });
  }

  saveStudyPlanResponse(planId, itemId, body) {
    return this.call(
      `/study-plans/${planId}/items/${itemId}/response`,
      PUT,
      body
    );
  }

  // Card 86akqxu0h: formulários de pesquisa enviados pela escola.
  getPendingSurveys() {
    return this.call("/surveys/pending", GET);
  }

  getSurvey(id) {
    return this.call(`/surveys/${id}`, GET);
  }

  submitSurvey(id, answers) {
    return this.call(`/surveys/${id}/responses`, POST, { answers });
  }

  // "Salvar" sem enviar: respostas até aqui e a página (seção) em que parou.
  saveSurveyDraft(id, answers, sectionId = null) {
    return this.call(`/surveys/${id}/draft`, PUT, { answers, sectionId });
  }

  // Card 86akj6ghg: o aluno marca (ou desmarca) o homework que recebeu.
  setHomeworkCompletion(noteId, done) {
    return this.call(`/course/notes/${noteId}/homework`, PUT, { done });
  }

  // Card 17trt6jbjf2 (retorno de 14/10): resposta ao homework, por escrito
  // e/ou com um arquivo (imagem ou PDF até 5 MB). Responder conclui.
  respondHomework(noteId, { text, file, removeFile }) {
    const data = new FormData();
    data.append("text", text || "");
    if (file) data.append("file", file);
    if (removeFile) data.append("removeFile", "true");
    return this.call(`/course/notes/${noteId}/homework/response`, POST, data, {
      "Content-Type": "multipart/form-data",
    });
  }

  // Homeworks pendentes de todas as aulas, para a home do aluno.
  getPendingHomework() {
    return this.call("/homework", GET);
  }

  participateInGeneralClass(id) {
    return this.call(`/general-classes/${id}/participate`, POST);
  }

  declineGeneralClass(id) {
    return this.call(`/general-classes/${id}/decline`, POST);
  }

  // Resposta do aluno depois da aula experimental (card 86ak6kzgj).
  resolveTrialInterest(classId, interested) {
    return this.call(`/groups/${classId}/trial-decision`, PUT, { interested });
  }

  // Card 86aknav25: o aluno corrige uma anotação já enviada ao mural.
  updateNote(noteId, note) {
    return this.call(`/course/notes/${noteId}`, PUT, { note });
  }

  // Resposta do aluno à nova data sugerida pelo professor (card 86aje36nz):
  // confirmar agenda a aula; recusar cancela a solicitação.
  respondTrialSuggestion(classId, accept) {
    return this.call(`/groups/${classId}/trial-suggestion`, PUT, { accept });
  }

  // Card 86akp2bkg: uma solicitação por vez (entrada em turma, turma nova ou
  // experimental). Retorna a que está aberta, ou null, e permite cancelá-la.
  openRequest() {
    return this.call("/requests/open", GET);
  }

  cancelRequest(classId) {
    return this.call(`/requests/${classId}/cancel`, PUT);
  }

  // Frequência e modalidade do aluno que migra do formato solo (card 86ak6k3u2).
  saveStudyPreferences(preferences) {
    return this.call("/study-preferences", PUT, preferences);
  }

  rearrange(eventId, classId) {
    return this.call(`/calendar/events/${eventId}/${classId}/rearrange`);
  }

  postergate(id, data) {
    return this.call(`/calendar/events/${id}`, PUT, data);
  }

  vote(id, option) {
    return this.call(`/calendar/vote/${id}`, POST, { agreed: option });
  }

  // Discordar de uma mudança de aula que o professor já aplicou. Não desfaz a
  // mudança: registra a justificativa para o professor avaliar.
  disputeClassChange(eventId, justification) {
    return this.call(`/calendar/events/${eventId}/dispute`, POST, {
      justification,
    });
  }

  // Card 17trt6jfxt2: registra a entrada na aula (base da presença sugerida).
  // Quem chama não espera nem trata falha: abrir o Meet vem primeiro.
  joinLesson(eventId) {
    return this.call(`/calendar/events/${eventId}/join`, POST);
  }

  listMyStudyGroups() {
    return this.call("/groups", GET);
  }

  listMyStudyGroupAttendance(groupId, params = {}) {
    return this.call(`/groups/${groupId}/attendance`, GET, params);
  }

  listMyCalendar() {
    return this.call("/calendar", GET);
  }

  // Card 86akng14v: cadastro pelo link do professor (rotas publicas).
  getStudentInvite(token) {
    return this.call(`/student-invites/${token}`, GET);
  }

  acceptStudentInvite(token, data) {
    return this.call(`/student-invites/${token}`, POST, data);
  }

  // Exercicios (card 17trt6jcyfb). O aluno do token e sempre o respondente.
  listLessonExercises(courseClassId) {
    return this.call(`/course/${courseClassId}/exercises`, GET);
  }

  // Games da aula (retorno de 18/10).
  listLessonGames(courseClassId) {
    return this.call(`/course/${courseClassId}/games`, GET);
  }

  // Retorno de 22/10: o aluno marca o jogo como concluído (ou desmarca).
  setGameCompletion(gameId, done) {
    return this.call(`/course/games/${gameId}/completion`, PUT, { done });
  }

  // Card 17trt6jfkw8: certificados emitidos pelo próprio aluno.
  getCertificatePreview() {
    return this.call("/certificates/preview", GET);
  }

  getCertificates() {
    return this.call("/certificates", GET);
  }

  issueCertificate() {
    return this.call("/certificates", POST);
  }

  // O PDF vem com o token do aluno, então não dá para ser só um link: baixa como
  // arquivo e quem chama salva.
  downloadCertificate(id) {
    return this.call(`/certificates/${id}/pdf`, GET, undefined, {}, "blob");
  }

  // A frente do certificado em imagem, para compartilhar nas redes.
  downloadCertificateImage(id) {
    return this.call(`/certificates/${id}/png`, GET, undefined, {}, "blob");
  }

  // Card 17trt6jfxtn: "Indicados pelo professor" e a marca de visto.
  getTeacherExtras() {
    return this.call("/course/extras", GET);
  }

  setTeacherExtraViewed(extraId, done) {
    return this.call(`/course/extras/${extraId}/viewed`, PUT, { done });
  }

  // A frente do certificado como sairia agora, para a prévia antes de emitir.
  getCertificatePreviewImage() {
    return this.call("/certificates/preview/png", GET, undefined, {}, "blob");
  }

  getExercise(exerciseId) {
    return this.call(`/exercises/${exerciseId}`, GET);
  }

  saveExerciseDraft(exerciseId, responses) {
    return this.call(`/exercises/${exerciseId}/draft`, PUT, { responses });
  }

  finishExercise(exerciseId, responses) {
    return this.call(`/exercises/${exerciseId}/finish`, POST, { responses });
  }
}

// Card 17trt6jbffe: metodos de Mensagens (shared/messagesApi.js).
installMessagesApi(PitchApi);

const api = new PitchApi(process.env.VUE_APP_PITCH_API_CUSTOMER);

export default api;
